module.exports = "/_next/static/images/ed-ho-64b3bc5f42979ef0fe0855a7304b46ab.jpg";